import { useEmailPreferences, useSetAnnouncements } from "../../hooks/useEmailPreferences";
import { MarketingUnsubscribe, type Props } from "./MarketingUnsubscribe";

/** The unsubscribe page's data: whose link it is, and the change asked for. */
export function MarketingUnsubscribeContainer({ token }: { token: string }) {
  const { data, isLoading, isError } = useEmailPreferences(token);
  const setAnnouncements = useSetAnnouncements(token);

  let state: Props["state"] = "loading";
  if (isError) state = "invalid";
  else if (data) state = data.subscribed ? "subscribed" : "unsubscribed";
  else if (!isLoading) state = "invalid";

  return (
    <MarketingUnsubscribe
      state={state}
      kind={data?.kind}
      email={data?.email}
      isSaving={setAnnouncements.isPending}
      error={
        setAnnouncements.isError
          ? "That didn’t go through. Please try again in a moment."
          : undefined
      }
      onUnsubscribe={() => setAnnouncements.mutate(false)}
      onResubscribe={() => setAnnouncements.mutate(true)}
    />
  );
}

export default MarketingUnsubscribeContainer;
